import React from "react";
import FileUpload from "./FileUpload";

const BrandLogoUpload = ({ uploadHandler, defaultValue }) => {
  return (
    <FileUpload
      currentValue={defaultValue}
      subtitle="SVG, PNG, JPG or GIF (max. 5MB)"
      allowedExtensions={[
        "image/png",
        "image/jpeg",
        "image/gif",
        "image/svg+xml",
      ]}
      maxFileSizeMB={5}
      onUpload={uploadHandler}
    />
  );
};

export default BrandLogoUpload;
